<br>
<div class="card card-default">
    <div class="card-header title_size">
        <h2 class="card-title">Edit Employee KPI</h2>
        <div class="card-tools">
            <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
            </button>
            <button type="button" class="btn btn-tool" data-card-widget="remove">
                <i class="fas fa-times"></i>
            </button>
        </div>
    </div>

    <div class="card-body">



        <div class="row">
            <div class="col-md-6">

                <div class="form-group">
                    <label>Select Month</label>
                    <input type="month" id="test" name="test" class="form-control form-control-lg" [(ngModel)]="Date"
                        (change)="MonthSelected()">
                </div>

            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Employee Name</label>
                    <input type="text" id="test" name="name" class="form-control form-control-lg"
                        [(ngModel)]="output[0].employee_name" disabled>
                </div>
            </div>
        </div>


        <section class="content">

            <div class="card">
                <div class="card-header">
                    <!--
            <h3 class="card-title Title">Employee Listing</h3>
            -->
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body p-0" style="overflow-x: auto;">
    <table class="table table-striped projects" id="employee_kpi" style="width: max-content;">
        <thead>
            <tr>
                <th style="width: 150px; position: sticky; left: 0; background-color: #fff; z-index: 10;">
                    Date
                </th>
                <th style="width: 120px;">Unposted Invoices</th>
                <th style="width: 120px;">Hardcopy Not Received</th>
                <th style="width: 120px;">RFR Over Due</th>
                <th style="width: 120px;">RFR Missed KPI</th>
                <th style="width: 120px;">RFT Over Due</th>
                <th style="width: 120px;">RFT Missed KPI</th>
                <th style="width: 120px;">Attendance</th>
                <th style="width: 120px;">Visit Plan Waiting</th>
                <th style="width: 120px;">Visit Plan Approved</th>
                <th style="width: 120px;">Projection KPI</th>
                <th style="width: 120px;">Invoice Transfer Trip</th>
                <th style="width: 120px;">Sale Order KPI</th>
                <th style="width: 120px; position: sticky; right: 120px; background-color: #fff; z-index: 10;">
                    Total
                </th>
                <th style="width: 120px; position: sticky; right: 0; background-color: #fff; z-index: 10;">
                    Action
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let c of output[0].count_list; index as i">
                <td style="position: sticky; left: 0; background-color: #fff; z-index: 5;">
                    <a>{{DateFormat(c.date)}}</a>
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.Unposted_invoices" 
                           (ngModelChange)="handleFieldChange(c, 'Unposted_invoices')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.hardcopy_not_received_invoices" 
                           (ngModelChange)="handleFieldChange(c, 'hardcopy_not_received_invoices')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.rfr_over_due_count" 
                           (ngModelChange)="handleFieldChange(c, 'rfr_over_due_count')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.rfr_missed_kpi_point" 
                           (ngModelChange)="handleFieldChange(c, 'rfr_missed_kpi_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.rft_over_due_count" 
                           (ngModelChange)="handleFieldChange(c, 'rft_over_due_count')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.rft_missed_kpi_point" 
                           (ngModelChange)="handleFieldChange(c, 'rft_missed_kpi_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.employee_attendance_point" 
                           (ngModelChange)="handleFieldChange(c, 'employee_attendance_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.visitPlanWaitingpoint" 
                           (ngModelChange)="handleFieldChange(c, 'visitPlanWaitingpoint')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.visitplanApprovedPoint" 
                           (ngModelChange)="handleFieldChange(c, 'visitplanApprovedPoint')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.projection_kpi_point" 
                           (ngModelChange)="handleFieldChange(c, 'projection_kpi_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.inv_transfer_trip_kpi_point" 
                           (ngModelChange)="handleFieldChange(c, 'inv_transfer_trip_kpi_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td>
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.sale_order_kpi_point" 
                           (ngModelChange)="handleFieldChange(c, 'sale_order_kpi_point')"
                           min="-999999" max="0" step="1">
                </td>

                <td style="position: sticky; right: 120px; background-color: #fff; z-index: 5;">
                    <input type="number" class="form-control form-control-lg"
                           [(ngModel)]="c.total" disabled>
                </td>

                <td class="project-actions text-right" style="position: sticky; right: 0; background-color: #fff; z-index: 5;">
                    <a class="btn btn-success btn-sm left" (click)="btnClick(c);">
                        <i class="fas fa-folder"></i>
                        Save
                    </a>
                </td>
            </tr>
        </tbody>
    </table>
</div>

            </div>

        </section>

        <!-- <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick();">Submit</button> -->

    </div>
</div>